module.exports = __webpack_public_path__ + "img/hero-md-2x.de404a5.webp";